import { useSyncExternalStore } from 'react';

/** Minimal observable state container for use with React's useSyncExternalStore. */
export class Store<T extends object> {
  private listeners = new Set<() => void>();
  constructor(private state: T) {}

  get = () => this.state;

  set(patch: Partial<T> | ((s: T) => Partial<T>)) {
    const next = typeof patch === 'function' ? patch(this.state) : patch;
    let changed = false;
    for (const k in next) if (!Object.is(next[k], this.state[k])) changed = true;
    if (!changed) return;
    this.state = { ...this.state, ...next };
    for (const l of this.listeners) l();
  }

  subscribe = (fn: () => void) => {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  };
}

export function useStore<T extends object>(store: Store<T>): T {
  return useSyncExternalStore(store.subscribe, store.get, store.get);
}
